module.exports = __webpack_public_path__ + "img/s02.f3d56cff.png";